import { render, staticRenderFns } from "./AttachOrder.vue?vue&type=template&id=4c3c3432&scoped=true"
import script from "./AttachOrder.vue?vue&type=script&lang=js"
export * from "./AttachOrder.vue?vue&type=script&lang=js"
import style0 from "./AttachOrder.vue?vue&type=style&index=0&id=4c3c3432&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3c3432",
  null
  
)

export default component.exports